/**
 * Converts timestamp string to human-readable time format
 * @param {string|number} timestamp - Timestamp string or number
 * @returns {string} Formatted time string
 */
export const convertToHumanReadableTime = (timestamp) => {
  // Convert timestamp to string if it's not already
  const timestampStr = String(timestamp);
  
  let timeVal = "AM";
  let hours = timestampStr.slice(6, 8);
  
  // Convert hours to number for comparison
  let hoursNum = parseInt(hours);
  if (hoursNum > 12) {
    hoursNum -= 12;
    timeVal = "PM";
  } else if (hoursNum === 0) {
    hoursNum = 12;
  } else if (hoursNum === 12) {
    timeVal = "PM";
  }
  
  // Format hours as a string
  hours = String(hoursNum);
  
  const minutes = timestampStr.slice(8, 10);
  const seconds = timestampStr.slice(10, 12);
  
  return `${hours}:${minutes}:${seconds} ${timeVal}`;
};

/**
 * Checks if a location is an SD location
 * @param {string} cameraIp - Camera IP address
 * @param {object} cameraLocations - Map of camera IPs to locations
 * @param {string} locationName - Name of the location
 * @returns {boolean} True if it's an SD location
 */

/**
 * Groups events by their timestamps into time buckets
 * @param {Array} events - Array of events
 * @param {number} bucketSizeMinutes - Size of each time bucket in minutes
 * @returns {Object} Events grouped by time buckets
 */
export const groupEventsByTime = (events, bucketSizeMinutes = 5) => {
  const buckets = {};
  const bucketSize = bucketSizeMinutes * 60 * 1000; // Convert to milliseconds
  
  events.forEach(event => {
    const timestamp = event.timestamp || Date.now();
    const bucketKey = Math.floor(timestamp / bucketSize) * bucketSize;
    
    if (!buckets[bucketKey]) {
      buckets[bucketKey] = [];
    }
    
    buckets[bucketKey].push(event);
  });
  
  return buckets;
};

// Utility function to normalize area values for consistent comparison
export const normalizeAreaValue = (value) => {
  if (typeof value === 'string') {
    // Convert to uppercase and trim any extra spaces
    return value.toUpperCase().trim();
  }
  return value;
};